import { useState, useEffect } from "react"
import { Box, CardContent, Divider, IconButton, Paper, Typography } from "@mui/material"
import CheckCircleIcon from "@mui/icons-material/CheckCircle"
import CancelIcon from "@mui/icons-material/Cancel"
import Grid from '@mui/material/Grid2';

interface PropertyDetailsProps {
  property: any
}

const PropertyDetails = ({ property }: PropertyDetailsProps) => {
  const [details, setDetails] = useState<Record<string, any>>({})
  const [isExpanded, setIsExpanded] = useState(false)

  useEffect(() => {
    if (property?.details) {
      try {
        const parsedDetails = JSON.parse(property.details)
        setDetails(parsedDetails)
      } catch (e) {
        console.error("Error parsing details:", e)
        setDetails({})
      }
    }
  }, [property?.details])

  const handleToggle = () => {
    setIsExpanded((prevState) => !prevState)
  }

  return (
    <Paper elevation={3} sx={{ padding: 2, mb: 2 }}>
      <CardContent>
        {/* Tipo de propiedad y Dimensión */}
        <Grid container spacing={2}>
          <Grid size={{xs:12, md:6}}>
            <Typography variant="h6" sx={{ mb: 1, fontWeight: "bold" }}>
              Tipo de propiedad
            </Typography>
            <Typography variant="body1">{property.categoryName}</Typography>
          </Grid>
          <Grid size={{xs:12, md:6}}>
            <Typography variant="h6" sx={{ mb: 1, fontWeight: "bold" }}>
              Dimensión
            </Typography>
            <Typography variant="body1">{property.dimension}</Typography>
          </Grid>
        </Grid>

        <Divider sx={{ my: 3, borderColor: "#e0e0e0", borderWidth: 0.5 }} />

        {/* Descripción */}
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            Descripción
          </Typography>
          <IconButton onClick={handleToggle} sx={{ ml: 1 }}>
            <Box component="img" src="/assets/images/search.png" alt="Toggle" sx={{ width: 20, height: 20 }} />
          </IconButton>
        </Box>

        <Box
          sx={{
            whiteSpace: "pre-line",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: isExpanded ? "block" : "-webkit-box",
            WebkitLineClamp: isExpanded ? "none" : 10,
            WebkitBoxOrient: "vertical",
          }}
        >
          {property.description}
        </Box>

        <Divider sx={{ my: 3, borderColor: "#e0e0e0", borderWidth: 0.5 }} />

        {/* Servicios y Comodidades */}
        <Grid container spacing={2}>
          <Grid size={{xs:12, md:6}}>
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              Servicios
            </Typography>
            <Typography variant="body1">{property.services}</Typography>
          </Grid>
          <Grid size={{xs:12, md:6}}>
            {property.amenities && property.amenities.trim() !== "" && (
              <>
                <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                  Comodidades
                </Typography>
                <Typography variant="body1">{property.amenities}</Typography>
              </>
            )}
          </Grid>
        </Grid>

        <Divider sx={{ my: 3, borderColor: "#e0e0e0", borderWidth: 0.5 }} />

        {/* Detalles */}
        <Grid container sx={{ mt: 2 }}>
          <Grid size={{xs:12}}>
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              Detalles
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
                p: 2,
              }}
            >
              {details &&
                Object.entries(details).map(([key, value]) => (
                  <Box key={key} sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Typography variant="body1">{key}:</Typography>
                    {value === "Sí" ? (
                      <CheckCircleIcon color="success" />
                    ) : value === "No" ? (
                      <CancelIcon color="error" />
                    ) : (
                      <Typography variant="body1">{value}</Typography>
                    )}
                  </Box>
                ))}
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Paper>
  )
}

export default PropertyDetails
